// 🔒
import { BrowserRouter, Routes, Route } from "react-router";
import MainLayout from "./MainLayout";
import LandingPage from "./pages/LandingPage";
import FAQPage from "./pages/FAQPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import TrainerProfilePage from "./pages/TrainerProfilePage";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<LandingPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
          <Route path="/:trainerSlug" element={<TrainerProfilePage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
// 🔒